module.exports = __webpack_public_path__ + "static/media/prazo1.eb588d42.png";